import Vue from 'vue'
import Vuex from 'vuex'

// 注册Vuex
Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    // 店铺类型全局变量
    TYPES: {
      WANGWANG: '200062', // "旺旺",
      JD: '200064', // "咚咚"
      WEIXIN: '200063', // "微信"
      WEB: '200067', // "WEB"
      MINIPROGRAM: '200070' // "微信小程序"
    },

    // 店铺相关
    shopList: [],
    currentShop: {},
    serviceTypes: [],

    // 淘金客相关
    userInfo: {},
    userStatus: '',
    userStatusLoad: false,

    conversationLoadStatus: false,
    conversationList: [],
    currentConversation: {},
    currentSessionId: null,
    conversationType: '',
    msgLoadStatus: false,
    sendContent: '',
    showEmotions: false,
    showSortBox: false,
    showSearchConversationList: false,
    keyHover: 0,
    showAtList: false,

    // 设置IM
    setImObj: {
      pifu: '',
      zuidahua: false
    },
    showSetImForm: false,

    // 消息记录
    loading: '<div class="loading-animation"><div class="box"><span></span></div></div>',
    msgLog: '',
    showMsgLog: false,
    loadMsgLog: false,

    // 转接
    showTransferTypeList: false,
    showTransferList: false,

    // AI智能辅助
    aiAuxiliaryAnswer: [],
    showAiAnswer: false,
    optimizationAi: {},
    showOptimizationAi: false,

    // 客户信息
    orderData: [],
    trackInfo: [],
    wwUserInfo: {},
    wwGoodsData: [],
    wwGoodsLoad: false,
    orderMark: {},
    orderEditAddress: '',

    // 右下角消息提醒
    notify: '',

    // 给已关闭会话发送消息后自动跳到当前会话列表并选中该会话标识
    autoSelectedSession: false
  },
  mutations: {
    changeShopList (state, arr) {
      state.shopList = arr;
    },
    changeCurrentShop (state, obj) {
      state.currentShop = obj;
    },
    changeServiceTypes (state, arr) {
      state.serviceTypes = arr;
    },
    changeUserInfo (state, obj) {
      state.userInfo = obj;
    },
    changeUserStatus (state, status) {
      state.userStatus = status;
    },
    changeUserStatusLoad (state, boolean) {
      state.userStatusLoad = boolean;
    },
    changeConversationLoadStatus (state, status) {
      state.conversationLoadStatus = status;
    },
    changeConversationList (state, list) {
      list = JSON.parse(JSON.stringify(list.map(o => {
        if(o.id == state.currentSessionId) {
          if (!o.data) {
            o.data = []
          }
        } else {
          delete o.data
        }
        return o
      })))
      state.conversationList = list
      let obj = list.find(o => o.id == state.currentSessionId) || {}
      state.currentConversation = obj
    },
    changeCurrentConversation (state, obj) {
      state.currentSessionId = obj && obj.id ? obj.id : null
      state.currentConversation = obj;
    },
    changeCurrentSessionId (state, val) {
      state.currentSessionId = val
      let obj = state.conversationList.find(o => o.id == val) || {}
      state.currentConversation = obj
    },
    changeConversationType (state, type) {
      state.conversationType = type;
    },
    changeMsgLoadStatus (state, status) {
      state.msgLoadStatus = status;
    },
    changeCloseCurrentSession (state) {
      let t = +new Date();
      state.closeCurrentSession = t;
    },
    changeSendContent (state, str) {
      state.sendContent = str;
    },
    changeKeyHover (state, index) {
      state.keyHover = index;
    },
    changeShowAtList (state, boolean) {
      state.showAtList = boolean;
    },
    changeSetImObj (state, obj) {
      state.setImObj = obj;
    },
    changeShowSetImForm (state, boolean) {
      state.showSetImForm = boolean;
    },
    changeShowEmotions (state, boolean) {
      state.showEmotions = boolean;
    },
    changeShowSortBox (state, boolean) {
      state.showSortBox = boolean;
    },
    changeShowSearchConversationList (state, boolean) {
      state.showSearchConversationList = boolean;
    },
    changeMsgLog (state, html) {
      state.msgLog = html;
    },
    changeShowMsgLog (state, boolean) {
      state.showMsgLog = boolean;
    },
    changeLoadMsgLog (state, boolean) {
      state.loadMsgLog = boolean;
    },
    changeOrderData (state, data) {
      state.orderData = data;
    },
    changeTrackInfo (state, data) {
      state.trackInfo = data;
    },
    changeWwUserInfo (state, obj) {
      state.wwUserInfo = obj;
    },
    changeWwGoodsData (state, data) {
      state.wwGoodsData = data;
    },
    changeWwGoodsLoad (state, boolean) {
      state.wwGoodsLoad = boolean;
    },
    changeOrderMark (state, obj) {
      state.orderMark = obj;
    },
    changeOrderEditAddress (state, data) {
      state.orderEditAddress = data;
    },
    changeShowTransferTypeList (state, boolean) {
      state.showTransferTypeList = boolean;
    },
    changeShowTransferList (state, boolean) {
      state.showTransferList = boolean;
    },
    changeAiAuxiliaryAnswer (state, data) {
      state.aiAuxiliaryAnswer = data;
    },
    changeShowAiAnswer (state, boolean) {
      state.showAiAnswer = boolean;
    },
    changeOptimizationAi (state, data) {
      state.optimizationAi = data;
    },
    changeShowOptimizationAi (state, boolean) {
      state.showOptimizationAi = boolean;
    },
    changeNotify (state, obj) {
      state.notify = obj;
    },
    changeAutoSelectedSession (state, boolean) {
      state.autoSelectedSession = boolean;
    }
  }
})


// WEBPACK FOOTER //
// ./src/config/store.js